import * as React from "react";
import { cn } from "@/lib/utils";

interface CheckboxV2Props extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "type"
> {
  label?: React.ReactNode;
}

export function CheckboxV2({
  label,
  className,
  id,
  ...props
}: CheckboxV2Props) {
  const generatedId = React.useId();
  const inputId = id ?? generatedId;

  return (
    <label
      htmlFor={inputId}
      className={cn(
        "inline-flex min-h-[40px] min-w-[40px] cursor-pointer items-center gap-2 text-sm text-[var(--v2-text-strong)]",
        props.disabled && "cursor-not-allowed opacity-60",
        className
      )}
    >
      <input
        id={inputId}
        type="checkbox"
        className="v2-focus-ring h-4 w-4 cursor-pointer rounded border-[var(--v2-border)] accent-[var(--v2-accent)]"
        {...props}
      />
      {label ? <span>{label}</span> : null}
    </label>
  );
}
